const init = {
  message: '',
  variant: ''
};

const notification = (state = init, action) => {
  switch (action.type) {
    case 'NOTIFICATION':
      return action.notification;
    default:
      return state;
  }
};

export default notification;
